import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineSyncIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M19.91 15.51h-4.53a1.0001 1.0001 0 0 0 0 2h2.4a7.9996 7.9996 0 0 1-8.7502 1.8972A7.9996 7.9996 0 0 1 4 12a1 1 0 1 0-2 0 10 10 0 0 0 16.88 7.23V21a1.0001 1.0001 0 0 0 2 0v-4.5a.9999.9999 0 0 0-.97-.99ZM12 2a10 10 0 0 0-6.88 2.77V3a1 1 0 0 0-2 0v4.5a1 1 0 0 0 1 1h4.5a1 1 0 0 0 0-2h-2.4A8 8 0 0 1 20 12a1.0001 1.0001 0 0 0 2 0 10.0009 10.0009 0 0 0-2.9289-7.071A10.0001 10.0001 0 0 0 12 2Z"/>
  </SvgIcon>
}

export default LineSyncIcon
